<template>

  <div class="advertiser-container">
    <div><i class="el-icon-s-unfold"></i>{{title}}</div>
    <el-row v-if="canNew" type="flex" style="margin-top:-1rem;" justify="end">
				<!-- <el-button @click="$router.push({name: 'EditWorkSheet', params: {Id:0}});"  icon="el-icon-plus" type="primary">创建工单
				</el-button> -->
        <el-button @click="onNewWorkSheet"  icon="el-icon-plus" type="primary">创建工单
				</el-button>
        <el-button @click="ExportList()"  icon="el-icon-plus" type="primary">导出
				</el-button>
	  </el-row>
    <el-form label-position="left" inline :model="productSearchForm" label-width="140px" style="margin-top: 10px;">
      <el-form-item label="工单日期">
        <!-- <el-date-picker
          style="    width: 251px;"
          v-model="productSearchForm.dateArray"
          type="daterange"
          range-separator="至"
          value-format="yyyy-M-d"
          start-placeholder="年/月/日"
          end-placeholder="年/月/日">
        </el-date-picker> -->
        <el-date-picker
          style="width:140px;"
          v-model="productSearchForm.sDate"
          type="date"
          placeholder="选择日期">
        </el-date-picker>至
        <el-date-picker
          style="width:140px;"
          v-model="productSearchForm.eDate"
          type="date"
          placeholder="选择日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item :label="isMobile?'':'工单类型'">
        <el-select clearable v-model="productSearchForm.typeIds" placeholder="选择工单类型">
          <el-option v-for="item in typeList" :key="item.value" :label="item.label"
            :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="工单状态">
		 <el-select clearable v-model="productSearchForm.statusId" placeholder="请选择">
			<el-option v-for="item in statusList" :key="item.value" :label="item.label"
				:value="item.value"></el-option>
		 </el-select>
	  </el-form-item> --> 

      <el-form-item :label="isMobile?'':'关键字'">
        <el-input clearable v-model="productSearchForm.key" autocomplete="off" placeholder="检索关键字"></el-input>
      </el-form-item>
      <el-form-item :label="isMobile?'':'处理人'">
        <el-select clearable v-model="handlerFilter" placeholder="选择处理人">
          <el-option v-for="item in handlerOptions" :key="item" :label="item" :value="item"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-checkbox v-model="productSearchForm.onlyTo21V">仅显示转21V</el-checkbox>
      </el-form-item>
      <el-button @click="onProductSearch" type="primary">搜索</el-button>
    </el-form>


<!-- :data="workSheetList" border :header-cell-style="{background:'#eef1f6',color:'#606266'}"
			style="width: 80%;margin-top: 10px;" ref="Table" :row-class-name="alertLevel_change" -->

    <el-table 
      :data="filteredList.slice((currentPage-1)*PageSize,currentPage*PageSize)"
      border :header-cell-style="{background:'#eef1f6',color:'#606266'}" 
			style="width: 80%;margin-top: 0px;" ref="Table"      
      >
        <!-- <el-table-column prop="id" align="center" label="数据编号" ></el-table-column> -->
      <!-- <el-table-column prop="sessionCode" align="center" label="通话编号" ></el-table-column> -->
      <el-table-column prop="sheetCode" align="center" width="108" label="工单编号">
        <template slot-scope="scope" >
             <div :style="{'color':scope.row.delay==1 && (scope.row.roleId==1  || scope.row.roleId=='9')?'red':'black'}">{{scope.row.sheetCode}}</div>
        </template>
      </el-table-column>
      <el-table-column :key="Math.random()" v-if="canNew && !isMobile" prop="comeFrom" align="center" width="50" label="来源"></el-table-column>
      
      <!-- <el-table-column prop="alertValue" align="center" label="工单编号" >
        <template slot-scope="scope" >
             <el-link v-if="scope.row.img"  :href="scope.row.img" target="_blank" type="primary">{{scope.row.sheetCode}}</el-link>
             <el-link v-else >{{scope.row.sheetCode}}</el-link>
        </template>
      </el-table-column> -->
      <el-table-column v-if="!isMobile" prop="companyType" align="center" width="80" label="客户类型" ></el-table-column> 
      <el-table-column prop="companyName" align="center" label="客户名称" ></el-table-column> 
      <el-table-column prop="msId" align="center" label="Microsoft ID" ></el-table-column> 
      <el-table-column v-if="!isMobile" prop="sheetTypes" align="center" width="80" label="工单类型" ></el-table-column>
      <el-table-column prop="title" align="center" label="工单主题" ></el-table-column>
      <el-table-column v-if="!isMobile" prop="dealUser" align="center" width="110" label="处理人" ></el-table-column>
      
      <el-table-column prop="alertValue" align="center"  width="50" label="紧急程度" >
        <template slot-scope="scope" >
             <div :style="{'color':scope.row.alertValue=='紧急'?'red':'#333'}">{{scope.row.alertValue}}</div>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="statusName" align="center" width="90" label="工单状态" 
        :filters="[{ text: '进行中', value: '进行中' },{ text: '进行中(转)', value: '进行中(转)' }, { text: '已结单', value: '已结单' }, { text: '已结单(转)', value: '已结单(转)' }, { text: '已关闭', value: '已关闭' }, { text: '已关闭(转)', value: '已关闭(转)' }]"
        :filter-method="filterStatus">
        <template slot-scope="scope" >
             <div :style="{'color':scope.row.statusName=='已结单'?'green':(scope.row.statusName=='已关闭'?'red':'#E58505')}">{{scope.row.to21V?scope.row.statusName+'(转)':scope.row.statusName}}</div>
        </template>
      </el-table-column> -->
      <el-table-column prop="statusName" align="center" width="90" label="工单状态" >
        <template slot-scope="scope" >
             <div :style="{'color':scope.row.statusName=='已结单'?'green':(scope.row.statusName=='已关闭'?'red':'#E58505')}">{{scope.row.to21V?scope.row.statusName+'(转)':scope.row.statusName}}</div>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="brand" align="center" label="品牌" ></el-table-column>
      <el-table-column prop="product" align="center" label="产品" ></el-table-column>
      <el-table-column prop="userName" align="center" label="监测员" ></el-table-column> -->
      <el-table-column v-if="!isMobile" prop="rowTime" align="center" width="100" label="创建时间" ></el-table-column>
      <!-- <el-table-column v-if="!isMobile" prop="curNode" align="center" width="80" label="当前节点" ></el-table-column> -->
      <!-- <el-table-column  align="center" label="操作" >
        <template slot-scope="scope">
          <el-button type="primary" size="small"
            @click.native.prevent="sourceItemOperation(scope.row)"
          >查看</el-button>
        </template>
      </el-table-column> -->
      <el-table-column  v-if="canNew && !isMobile" prop="dealLength" align="center" width="77" label="处理时长"></el-table-column>

      <el-table-column  v-if="loginInfo.roleId==1 && !isMobile" prop="jxsName" align="center" width="150" label="经销商"></el-table-column>
      <el-table-column  v-if="loginInfo.roleId==1 && !isMobile" prop="contactUser" align="center" width="100" label="用户"></el-table-column>
      <el-table-column  v-if="loginInfo.roleId==1 && !isMobile" prop="email" align="center" width="100" label="邮箱"></el-table-column>
      <el-table-column  v-if="loginInfo.roleId==1 && !isMobile" prop="tel" align="center" width="100" label="电话"></el-table-column>
      <el-table-column  v-if="loginInfo.roleId==1 && !isMobile" prop="account" align="center" width="200" label="域名"></el-table-column>
      <el-table-column  v-if="loginInfo.roleId==1 && !isMobile" prop="address" align="center" width="200" label="地址"></el-table-column>

      <el-table-column  align="center" label="操作" :width="canNew && !isMobile?'180':'90'" fixed="right">
        <template slot-scope="scope">
          <el-button-group>
            <div style="display:flex;padding-right:0.2rem;">
              <div class="btnGrp">
                <el-button type="primary" size="mini"  @click.native.prevent="onItemEditClick(scope.row,1)">{{scope.row.statusName=='已结单'?'查看':'跟进'}}</el-button>
                <el-button v-if="canNew && scope.row.statusName!=='已结单' && scope.row.statusName!=='已关闭'" type="warning" size="mini"
                  @click.native.prevent="onItemCloseClick(scope.row)"
                >关闭</el-button>
                <el-button v-if="canNew && scope.row.statusName!=='已结单' && scope.row.statusName!=='已关闭' && scope.row.haveReply==1" type="danger" size="mini"
                  @click.native.prevent="onItemFinishClick(scope.row)"
                >结单</el-button>    
                <el-button v-if="scope.row.roleId=='1' || scope.row.roleId=='9'" :type="scope.row.visitRemark?'primary':'danger'" size="mini"
                  @click.native.prevent="onItemSetRemarkClick(scope.row,2)">回访说明</el-button>  
              </div>
              <div class="btnGrp">
                <el-button v-if="canNew && scope.row.to21V && scope.row.statusName!=='已关闭'" :type="scope.row.code21V?'primary':'danger'" size="mini"
                  @click.native.prevent="onItemSet21VCodeClick(scope.row)"
                >21V单号</el-button>
                <el-button v-if="scope.row.isManager==1 && scope.row.statusName=='已结单' && scope.row.haveReply==1" type="danger" size="mini"
                  @click.native.prevent="onItemSetTimeClick(scope.row)"
                >调整</el-button>            
                <el-button v-if="scope.row.roleId=='1' || scope.row.roleId=='9'" :type="scope.row.satisfyRemark?'primary':'danger'" size="mini"
                  @click.native.prevent="onItemSetRemarkClick(scope.row,1)">满意度</el-button>
                
                <el-button v-if="scope.row.roleId=='1' || scope.row.roleId=='9'" :type="scope.row.remark?'primary':'info'" size="mini"
                  @click.native.prevent="onItemSetRemarkClick(scope.row,3)">备注</el-button>
                <el-button v-if="(scope.row.roleId=='1' || scope.row.roleId=='9') && scope.row.sessionCode=='微信'" :type="scope.row.wxFiles?'primary':'danger'" size="mini"
                  @click.native.prevent="onItemWxFileClick(scope.row)">微信截屏</el-button>  
              </div>
            </div>
                  
            
            <!-- <el-button type="primary" size="mini"  @click.native.prevent="onItemEditClick(scope.row,1)">{{scope.row.statusName=='已结单'?'查看':'跟进'}}</el-button>
            <el-button v-if="canNew && scope.row.statusName!=='已结单' && scope.row.statusName!=='已关闭'" type="warning" size="mini"
              @click.native.prevent="onItemCloseClick(scope.row)"
            >关闭</el-button>
            <el-button v-if="canNew && scope.row.statusName!=='已结单' && scope.row.statusName!=='已关闭' && scope.row.haveReply==1" type="danger" size="mini"
              @click.native.prevent="onItemFinishClick(scope.row)"
            >结单</el-button>            
            <el-button v-if="canNew && scope.row.to21V && scope.row.statusName!=='已关闭'" :type="scope.row.code21V?'primary':'danger'" size="mini"
              @click.native.prevent="onItemSet21VCodeClick(scope.row)"
            >21V单号</el-button>
            <el-button v-if="scope.row.isManager==1 && scope.row.statusName=='已结单' && scope.row.haveReply==1" type="danger" size="mini"
              @click.native.prevent="onItemSetTimeClick(scope.row)"
            >调整</el-button>            
            <el-button v-if="scope.row.roleId=='1' || scope.row.roleId=='9'" :type="scope.row.satisfyRemark?'primary':'danger'" size="mini"
              @click.native.prevent="onItemSetRemarkClick(scope.row,1)">满意度说明</el-button>
            <el-button v-if="scope.row.roleId=='1' || scope.row.roleId=='9'" :type="scope.row.visitRemark?'primary':'danger'" size="mini"
              @click.native.prevent="onItemSetRemarkClick(scope.row,2)">回访说明</el-button>
            <el-button v-if="scope.row.roleId=='1' || scope.row.roleId=='9'" :type="scope.row.remark?'primary':'info'" size="mini"
              @click.native.prevent="onItemSetRemarkClick(scope.row,3)">备注</el-button>
            <el-button v-if="(scope.row.roleId=='1' || scope.row.roleId=='9') && scope.row.sessionCode=='微信'" :type="scope.row.wxFiles?'primary':'danger'" size="mini"
              @click.native.prevent="onItemWxFileClick(scope.row)">微信截屏</el-button>             -->
          </el-button-group> 
        </template>
      </el-table-column>
    </el-table>

    <div class="tabListPage">
           <el-pagination @size-change="handleSizeChange" 
                          @current-change="handleCurrentChange" 
                          :current-page="currentPage" 
                          :page-sizes="pageSizes" 
                          :page-size="PageSize" layout="total, sizes, prev, pager, next, jumper" 
                          :total="filteredList.length">
             </el-pagination>
    </div>
    <change-time :visible.sync="setTimeVisible" :current-item="currentItem" @saved="onProductSearch"/>
    <el-dialog :title="dialogTitle" :visible="remarkDialogVisible" width="70%"
                             :modal-append-to-body='false'
                             :close-on-click-modal='false'
                              @close="remarkDialogVisible = false" 
                              :show-close="false"
                              class="dialogupdown0"
                             append-to-body>
					<el-form :model="remarkForm" inline style="margin-top: 30px;">
            <el-row>
              <el-form-item label="工单主题">
                  <div>{{remarkForm.title}}</div>
              </el-form-item>
            </el-row>
            <el-row v-if="remarkForm.flag==1">
              <!-- <el-form-item label="满意度说明">
                  <el-input v-model="remarkForm.satisfyRemark" type="text" autocomplete="off"
                            class="text-width"></el-input>
              </el-form-item>  -->
              <el-form-item class="remark" label="满意度说明" style="width: 100%;margin-top:5px;">
                <el-col :span="24">
                  <el-input v-model="remarkForm.satisfyRemark" size="medium" :rows="5" type="textarea"
                  autocomplete="off" placeholder="请输入满意度说明" style="width:100%"
                  ></el-input>
                </el-col>
              </el-form-item>       

            </el-row>       
            <el-row v-if="remarkForm.flag==2">
              <!-- <el-form-item label="回访说明">
                  <el-input v-model="remarkForm.visitRemark" type="text" autocomplete="off"
                            class="text-width"></el-input>
              </el-form-item>  -->
              <el-form-item class="remark" label="回访说明" style="width: 100%;margin-top:5px;">
                <el-col :span="24">
                  <el-input v-model="remarkForm.visitRemark" size="medium" :rows="5" type="textarea"
                  autocomplete="off" placeholder="请输入回访说明" style="width:100%"
                  ></el-input>
                </el-col>
              </el-form-item>    
            </el-row>   
            <el-row v-if="remarkForm.flag==3">
              <el-form-item class="remark" label="备注" style="width: 100%;margin-top:5px;">
                <el-col :span="24">
                  <el-input v-model="remarkForm.remark" size="medium" :rows="5" type="textarea"
                  autocomplete="off" placeholder="请输入备注" style="width:100%"
                  ></el-input>
                </el-col>
              </el-form-item>    
            </el-row>                                           
				</el-form>

				<div slot="footer" class="dialog-footer">
						<el-button type="danger" @click="remarkDialogVisible = false">关闭</el-button>
						<el-button type="primary" @click="onSaveRemark">保存</el-button>
				</div>
		</el-dialog>

    <el-dialog title="微信截屏文件" :visible="wxFileDialogVisible" width="70%"
                             :modal-append-to-body='false'
                             :close-on-click-modal='false'
                              @close="wxFileDialogVisible = false" 
                              :show-close="false"
                             append-to-body>
        <el-form :model="wxFileForm" inline style="margin-top: 30px;">
          <my-upload-file-form-item v-model="wxFileForm.sample" label="附件" :limit="10" />
        </el-form>

				<div slot="footer" class="dialog-footer">
						<el-button type="danger" @click="wxFileDialogVisible = false">关闭</el-button>
						<el-button type="primary" @click="onSaveWxFile">保存</el-button>
				</div>
		</el-dialog>

    <el-dialog title="查看" :visible.sync="ckDialogVisible" width="90%" v-if="ckDialogVisible"
                             :close-on-click-modal='false'
                             :z-index="99999"
                              @close="ckDialogVisible = false" 
                              :show-close="false"
                              :modal-append-to-body='false'>
        <!-- <div style="background-color: #fff;"> -->
          <sheet-view-parent ref="ckWindow" :id="id_para"  @onclose="closeCk"/>
        <!-- </div> -->
				<div slot="footer" class="dialog-footer">
						<!-- <el-button @click="ckDialogVisible = false">关闭</el-button> -->
            <div>.</div>
						<!-- <el-button type="primary" @click="onSaveWxFile">保存</el-button> -->
				</div>
		</el-dialog>
    <el-dialog title="工单处理" :visible.sync="gjDialogVisible" v-if="gjDialogVisible" width="70%"
                             :close-on-click-modal='false'
                             :z-index="99999"
                              @close="gjDialogVisible = false" 
                              :show-close="false"
                              :modal-append-to-body='false'>
        <!-- <div style="background-color: #fff;"> -->
          <edit-work-sheet ref="gjWindow" :id="id_para"  @onclose="closeGj"/>
        <!-- </div> -->

				<div slot="footer" class="dialog-footer">
						<!-- <el-button @click="ckDialogVisible = false">关闭</el-button> -->
            <div>.</div>
						<!-- <el-button type="primary" @click="onSaveWxFile">保存</el-button> -->
				</div>
		</el-dialog>

    <el-dialog title="填写21V工单号" :visible="set21VCodeVisible" width="70%"
                             :modal-append-to-body='false'
                             :close-on-click-modal='false'
                              @close="set21VCodeVisible = false" 
                              :show-close="false"
                             append-to-body>
        <el-form :model="gdhForm" inline style="margin-top: 30px;">
          21V单号：<el-input v-model="gdhForm.code21V" style="width:40%;"></el-input>
        </el-form>

				<div slot="footer" class="dialog-footer">
						<el-button type="danger" @click="set21VCodeVisible = false">关闭</el-button>
						<el-button type="primary" @click="onSave21VCode">保存</el-button>
				</div>
		</el-dialog>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable";
import {getLatestMonthDateArrayByDate} from "@/utils/time";
import { mapGetters } from "vuex";
import { getToken } from "@/utils/auth";
import {encrypt} from "@/utils/encrypt";
import {setFinish,SetRemark,SendEmail,SaveWxFile,Set21VCode,getWorkSheetDetailAll2024} from "@/api/workSheet";
import ChangeTime from "@/views/WorkSheet/ChangeTime";
import { getSampleArrayFromSever } from "@/views/WorkSheet/xml-manager";
import MyUploadFileFormItem from "@/components/MyUploadFileFormItem";
import EditWorkSheet  from "@/views/WorkSheet/WorkSheetEdit";
import SheetViewParent  from "@/views/WorkSheet/SheetViewParent";

export default {
  name: "Advertiser",
  components: { CommonTable,ChangeTime,MyUploadFileFormItem,EditWorkSheet,SheetViewParent}, 
  props: ['menuModuleId'],
  computed: {
    ...mapGetters(["workSheetList","typeList","statusList","roleName","isMobile"]),
    // 从当前表格数据中提取去重的处理人列表
    handlerOptions() {
      const set = new Set();
      this.workSheetList.forEach(item => {
        if (item.dealUser) set.add(item.dealUser);
      });
      return Array.from(set);
    },
    // 按处理人前端过滤（appliedHandlerFilter 只在点击搜索时更新，保证与其他字段交互统一）
    filteredList() {
      if (!this.appliedHandlerFilter) return this.workSheetList;
      return this.workSheetList.filter(item => item.dealUser === this.appliedHandlerFilter);
    },
  },
  data() {
    return {
      loginInfo:{},
      set21VCodeVisible:false,
      ckDialogVisible:false,
      gjDialogVisible:false,
      title:'待办工单',
      canNew:false,
      handlerFilter:'',
      appliedHandlerFilter:'',
      editOrderDialogVisible: false,
      setTimeVisible:false,
      productSearchForm: {
        key: "",
        dateArray: getLatestMonthDateArrayByDate({date:new Date(),delayNum:1, formatValue: 'yyyy-MM-dd'}),
        typeIds:'',
        statusId:'',
        sDate:getLatestMonthDateArrayByDate({date:new Date(),delayNum:1, formatValue: 'yyyy-MM-dd'})[0],
        eDate:getLatestMonthDateArrayByDate({date:new Date(),delayNum:1, formatValue: 'yyyy-MM-dd'})[1],
        onlyTo21V:false,
      },
      remarkForm:{
        id:0,
        title:'',
        satisfyRemark:'',
        visitRemark:'',  
        remark:'',      
        flag:1,
      },
      currentItem: {},
      gdhForm:{
        code21V:''
      },
      // 默认显示第几页
      currentPage:1,
      // 总条数，根据接口获取数据长度(注意：这里不能为空)
      // 个数选择器（可修改）
      pageSizes:[20,50,100],
      // 默认每页显示的条数（可修改）
      PageSize:50,
      dialogTitle:'',
      remarkDialogVisible:false,
      wxFileDialogVisible:false,
      wxFileForm:{
        id:'',
        sample:[],
        userId:''
      },
      id_para:'',
    };
  },
  async activated() {
      console.log('activated')
    //   await this.onProductSearch();
  },

  updated(){
    // console.log('updated')
    // this.onProductSearch();
  },
  

  watch: {
    $route(to, from) {
        // console.log('route to',to)
        // console.log('route from',from)
        // console.log('route query',this.$route.query)
        // console.log('route params',this.$route.params,this.$route.params.menuModuleId)
        // // console.log('route change',to,from,this.$route.query,this.$route.params,this.menuModuleId)
        switch(this.menuModuleId){
          case '1':
            this.title="我发起的工单";
            break;
          case '2':
            this.title="待办工单";
            break;
          case '3':
            this.title="已完成工单";
            break;
          case '4':
            this.title="抄送我的工单";
            break;
          case '5':
            this.title="处理中工单";
            break;
          default:
            this.title="";
            break;
        }
        if (this.$route.params.menuModuleId) {
            this.onProductSearch();
        }
      },
  },
    // // 或者
    // $route(){
    //      if (this.$route.query.参数) {
    //          重新加载一次created或者mounted钩子中的渲染的数据
    //      }
    //    }, 
    // },


  async created() {
    // console.log('cao!!!!!!!!!!!!!!!!')
    this.loginInfo = JSON.parse(localStorage.getItem('loginInfo'))
    // console.log('li',this.loginInfo,this.loginInfo.roleId)
    //   console.log("aa")
    await this.$store.dispatch("workSheet/typeList", {userId:getToken()});
    // console.log("bb")
    await this.$store.dispatch("workSheet/statusList", {userId:getToken()});
    this.$store.dispatch("setting/checkDevice");
    // console.log("cc")
    // console.log('typeList',this.typeList)
    // console.log('statusList',this.statusList)
    this.onProductSearch();

    
  },
  // async mounted() {
  //   var condi = localStorage.getItem('productSearchCondition');
  //   if (condi){
  //     this.productSearchForm = JSON.parse(condi);
  //     // console.log('condi 2',condi);
  //   }
  // },
  methods: {    
    // 分页
    // 每页显示的条数
    handleSizeChange(val) {
      // 改变每页显示的条数 
      this.PageSize=val
      // 注意：在改变每页显示的条数时，要将页码显示到第一页
      this.currentPage=1
    },
      // 显示第几页
    handleCurrentChange(val) {
        // 改变默认的页数
        this.currentPage=val
    },

    async onSendEmail(item){
      await SendEmail({userId: getToken(), wsId: encrypt(item.id)}).then(()=>{
        this.$message('已发送');
      })  
    },
    onItemWxFileClick(item){
      if (item.wxFiles == null || item.wxFiles == ''){
        this.wxFileForm.sample = []
      }else{
        this.wxFileForm.sample = getSampleArrayFromSever({sample:item.wxFiles})
      }
      this.wxFileForm.id = item.id
      this.wxFileDialogVisible = true
    },
    async onSaveWxFile(){
      //
      // console.log('aaa',this.wxFileForm.sample)
      this.wxFileForm.userId = encrypt(getToken());
      await SaveWxFile(this.wxFileForm).then((res)=>{
        if (res.data.data.Result !== 1){
          this.$error.warning(res.data.data.Msg)
        }else{
          var files=''
          this.wxFileForm.sample.forEach(ele => {
            if (files==''){
              files = ele.name
            }else{
              files += ';'+ele.name
            }
          });
          this.workSheetList.forEach(ele => {
            if (ele.id == this.wxFileForm.id){
              ele.wxFiles = files
            }
          });
          // this.onProductSearch()
          this.wxFileDialogVisible = false
        }
      })
    },
    onItemSetRemarkClick(item,flag){
      this.remarkForm.id=item.id;
      this.remarkForm.flag=flag;
      this.remarkForm.title=item.title;
      this.remarkForm.satisfyRemark=item.satisfyRemark;
      this.remarkForm.visitRemark=item.visitRemark;
      this.remarkForm.remark=item.remark;
      
      if (flag==1)
        this.dialogTitle ="满意度说明";
      else if (flag==2)
        this.dialogTitle = "回访说明";
      else
        this.dialogTitle = "备注";
      this.remarkDialogVisible= true;
      console.log('aa',this.remarkDialogVisible)
    },


    async onSaveRemark(){
      if (this.remarkForm.flag==1){
        await SetRemark({userId: getToken(), wsId: this.remarkForm.id,remark:this.remarkForm.satisfyRemark,flag:1});        
      }else if (this.remarkForm.flag==2){
        await SetRemark({userId: getToken(), wsId: this.remarkForm.id,remark:this.remarkForm.visitRemark,flag:2});    
      }
      else{
        await SetRemark({userId: getToken(), wsId: this.remarkForm.id,remark:this.remarkForm.remark,flag:3});   
      }
      this.$message.success('操作成功');
      this.workSheetList.forEach(ele => {
        if (ele.id == this.remarkForm.id){
          ele.satisfyRemark = this.remarkForm.satisfyRemark
          ele.visitRemark = this.remarkForm.visitRemark
          ele.remark = this.remarkForm.remark
        }
      });
      this.remarkDialogVisible= false;
      // await this.onProductSearch();
    },

    async ExportList(){
      var _this=this;
		  // const [sDate, eDate] = this.productSearchForm;//.dateArray;
      var sDate = new Date(this.productSearchForm.sDate).toLocaleDateString();
      var eDate = new Date(this.productSearchForm.eDate).toLocaleDateString();
		  await _this.$store.dispatch('workSheet/exportWorkSheetList', {
							sDate:sDate,
							eDate:eDate,
			});
    },

    async onItemEditClick(item,flag) {
      var id =encrypt(item.id);
      this.id_para = id
      if (flag==0){
		    // this.$router.push({name: 'EditWorkSheet', params: {Id: id}});
        this.gjDialogVisible=true
        console.log('0',flag)
      }
      else{
        // this.$router.push({name: 'SheetViewParent', params: {Id: id}});
        
        this.ckDialogVisible = true
        console.log('1',flag)
      }
	},
  onNewWorkSheet(){
    this.id_para = 0
    this.gjDialogVisible=true
    // $router.push({name: 'EditWorkSheet', params: {Id:0}});
  },

  closeGj(fresh){
    this.gjDialogVisible=false
    if (fresh){
      this.onProductSearch();
    }    
  },
  closeCk(fresh){
    this.ckDialogVisible=false
    console.log('fresh',fresh)
    if (fresh){
      this.onProductSearch();
    }   
  },

  async onItemCloseClick(item){
    await this.$alert('确认关闭？', '提示', {
								showCancelButton: true,
								type: "info",
								confirmButtonText: '确定',
								cancelButtonText: '取消',
						}).then(async () => {
								await setFinish({userId: getToken(), wsId: item.id,type:2,finished:true});
                this.$message.success('操作成功');
                await this.onProductSearch();
						});    
  },

  async onItemSetTimeClick(item){
    // GetWorkSheetList不再返回content，打开调整窗口前先取一次详情补全内容
    const {data} = await getWorkSheetDetailAll2024({userId: getToken(), Id: encrypt(item.id)});
    item.content = data.main.content;
    if (!item.itemContent && data.sub.obj.length > 0){
      item.itemContent = data.sub.obj[0].itemContent ? data.sub.obj[0].itemContent : '';
    }
    this.currentItem = item;
    this.setTimeVisible = true;
  },
  async onItemSet21VCodeClick(item){
    this.currentItem = item;
    this.gdhForm.code21V = item.code21V
    this.set21VCodeVisible = true;
  },
  async onSave21VCode(){
    var data={
      userId:getToken(),
      Id:this.currentItem.id,
      code21V:this.gdhForm.code21V
    }
    await Set21VCode(data).then((res)=>{
      console.log('res',res)
      if (res.data.data.Result === 1){
        this.currentItem.code21V = this.gdhForm.code21V
        this.set21VCodeVisible = false;
      }
      
    })
  },

  async onItemFinishClick(item){
    var that = this
    await this.$alert('确认结单？', '提示', {
								showCancelButton: true,
								type: "info",
								confirmButtonText: '确定',
								cancelButtonText: '取消',
						}).then(async () => {
								await setFinish({userId: getToken(), wsId: item.id,type:1,finished:true});
                this.$message.success('操作成功');
                // await this.onProductSearch();
                that.workSheetList.forEach(ele => {
                  if (ele.id == item.id){
                    ele.statusName = '已结单'
                  }
                });
						});

    
  },

    async onProductSearch() {
      console.log(this.productSearchForm);
      if (this.roleName=="系统组" || this.roleName=="工单组"){
            this.canNew=true;
      }
      // console.log('aa',this.productSearchForm);
      // const [sDate, eDate] = this.productSearchForm.dateArray;
      // const {sDate, eDate} = this.productSearchForm;
      var sDate = new Date(this.productSearchForm.sDate).toLocaleDateString();
      var eDate = new Date(this.productSearchForm.eDate).toLocaleDateString();
      // console.log('bb',sDate,eDate,this.productSearchForm);
      const toast = this.$loading({
            lock: true,
            text: '搜索中...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });
        try{
          await this.$store.dispatch("workSheet/workSheetList", {
            sDate:sDate,
            eDate:eDate,
            typeIds:this.productSearchForm.typeIds,
            statusId:this.productSearchForm.statusId,
            menuModuleId:this.menuModuleId,//1,
            key: this.productSearchForm.key,
            onlyTo21V:this.productSearchForm.onlyTo21V,
          }).then(res=>{
              this.$refs.Table.doLayout();
              this.appliedHandlerFilter = this.handlerFilter;
              this.currentPage=1

          });
        }finally{
            toast.close()
        }

    //   setTimeout(() => {
    //         this.$nextTick(() => {
    //             this.$refs.Table.doLayout()
    //         })
    //     }, 300)

    },

    alertLevel_change: function (row) {
      
        if (row.row.alertLevel === 11) {
          // console.log('alertLevel_change',row.row.alertLevel)
          return 'table-info-row'
        }
    },

    filterStatus(value, row, column) {
      const statProperty = column['property'];
      // const toProperty = column['to21V'];
      // console.log('statProperty',statProperty)
      var rowVal=row[statProperty]
      if (row['to21V']){
        rowVal+='(转)'
      }
      return rowVal === value;      
    }

  },
};
</script>

<style scoped>
.dialogupdown0>>>.el-dialog__body {
    padding: 0px 20px;
}
.btnGrp{
  text-align:  center;
  width:50%;
}
.btnGrp >>> .el-button--mini{
  width: 4.5rem;
}
.btnGrp >>> .el-button + .el-button{
  margin-left:0rem;
}
/* /deep/ .el-dialog__header{
  display:none
} */
  
.error{
    color: red;
}
.ok{
    color: green;
}
.table-info-row td {
      color: red;
 }
 .el-pagination {
    text-align: right; 
}

.remark >>> .el-form-item__content{
  width:100%;
}
</style>

<style>
.el-message-box{
    width: 280px;
  }
</style>